import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "../components/UI/Button";

export type TDialogResult = number | null;
export type TButtonBar = { text: string; action: TDialogResult; required?: boolean }[];
export type TTextFieldProps = { disabled: boolean; value: string; label?: string }[];

export interface IDialogCookieBanner {
  open: boolean;
  onClose: () => void;
}

export function DialogCookieBanner(props: IDialogCookieBanner) {
  const onClose = () => {
    props.onClose();
  };

  return (
    <Dialog open={props.open} fullWidth>
      <DialogTitle className={`flex content-center justify-center`}>Cookie Richtlininen</DialogTitle>
      <div className="px-6 pb-6 rounded-lg shadow-lg bg-white">
        <p>Die Website benutzt nur funktional erfoderliche Cookies. Es werden keine Maketing- oder Tracking-Cookies verwendet.</p>
        <div className="grid w-full place-items-center">
          <Button className="w-2/4 my-5" onClick={onClose}>Zustimmen und speichern</Button>
        </div>
      </div>
    </Dialog>
  );
}
